import { render, staticRenderFns } from "./banana.vue?vue&type=template&id=b08a7634"
import script from "./banana.vue?vue&type=script&lang=js"
export * from "./banana.vue?vue&type=script&lang=js"
import style0 from "./banana.vue?vue&type=style&index=0&id=b08a7634&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports